exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Markdown-Inline,.Markdown-Inline *{display:inline}.Markdown ol,.Markdown p,.Markdown ul{margin-bottom:0}.Markdown ol,.Markdown ul{padding-left:20px}", "", {"version":3,"sources":["/./src/app/components/shared/src/app/components/shared/Markdown.scss"],"names":[],"mappings":"AACG,oCAGG,cAAe,CAJrB,sCASI,eAAgB,CATpB,0BAaI,iBAAkB,CACnB","file":"Markdown.scss","sourcesContent":[".Markdown {\n  &-Inline {\n    display: inline;\n    * {\n      display: inline;\n    }\n  }\n\n  ol, p, ul {\n    margin-bottom: 0;\n  }\n\n  ol, ul {\n    padding-left: 20px;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?sourceMap!./~/sass-loader?sourceMap&includePaths[]=/home/circleci/project/bower_components&includePaths[]=/home/circleci/project/node_modules!./~/postcss-loader!./src/app/components/shared/Markdown.scss
 ** module id = 1158
 ** module chunks = 1
 **/